import React, { useState } from 'react';
import { Lock, Loader2 } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const ChangePasswordCard = ({ api }) => {
  const [passwords, setPasswords] = useState({ current: '', new_pw: '', confirm: '' });
  const [pwMessage, setPwMessage] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPwMessage('');
    if (passwords.new_pw !== passwords.confirm) {
      setPwMessage('New passwords do not match');
      return;
    }
    if (passwords.new_pw.length < 6) {
      setPwMessage('Password must be at least 6 characters');
      return;
    }
    setSaving(true);
    try {
      await api.post('/auth/change-password', {
        current_password: passwords.current,
        new_password: passwords.new_pw
      });
      setPwMessage('Password changed successfully!');
      setPasswords({ current: '', new_pw: '', confirm: '' });
    } catch (error) {
      setPwMessage(error.response?.data?.detail || 'Failed to change password');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="border-brand-primary/10 mt-6" data-testid="change-password-section">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Lock className="w-5 h-5 text-brand-primary" />
          Change Password
        </CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="current_password">Current Password</Label>
            <Input
              id="current_password"
              type="password"
              value={passwords.current}
              onChange={(e) => setPasswords({ ...passwords, current: e.target.value })}
              placeholder="Enter current password"
              data-testid="current-password-input"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="new_password">New Password</Label>
              <Input
                id="new_password"
                type="password"
                value={passwords.new_pw}
                onChange={(e) => setPasswords({ ...passwords, new_pw: e.target.value })}
                placeholder="Min 6 characters"
                data-testid="new-password-input"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="confirm_password">Confirm New Password</Label>
              <Input
                id="confirm_password"
                type="password"
                value={passwords.confirm}
                onChange={(e) => setPasswords({ ...passwords, confirm: e.target.value })}
                placeholder="Confirm new password"
                data-testid="confirm-password-input"
              />
            </div>
          </div>
          {pwMessage && (
            <p className={`text-sm ${pwMessage.includes('success') ? 'text-green-600' : 'text-red-500'}`} data-testid="password-message">
              {pwMessage}
            </p>
          )}
          <div className="flex justify-end">
            <Button type="submit" disabled={saving} className="btn-primary gap-2" data-testid="change-password-button">
              {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />}
              Update Password
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};
